/* What `/plans/nowy`'s restore question adds inside the page's notice: the card at the width the
 * dialog gives it, so the same plan reads the same way on both prompts, and the answers under it.
 * The notice's column, heading and sentence are `pages/plan-builder`'s `BuilderNotice`. */

.answers {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: center;
  width: min(100%, 420px);
  margin-top: var(--space-2);
}

.card {
  align-self: stretch;
}

.actions {
  display: flex;
  gap: var(--space-2);
  justify-content: center;
}
